import React, { Component } from "react";

class ImageLoader extends Component {
  render() {
    return (
      <img
        src="/admin/img/loading.gif"
        style={{ width: "25px", display: "block", margin: "auto" }}
      />
    );
  }
}

export default ImageLoader;
